// Product Accordian

// const headers = document.querySelectorAll(".accordion-header");

//     headers.forEach(header => {
//       header.addEventListener("click", () => {

//         const item = header.parentElement;
//         const content = item.querySelector(".accordion-content");

//         item.classList.toggle("active");
//         content.classList.toggle("hidden");

//       });
//     });



const headers = document.querySelectorAll(".accordion-header");

headers.forEach(header => {
  header.addEventListener("click", () => {

    const item = header.parentElement;

    // close all other accordions
    document.querySelectorAll(".accordion-item").forEach(el => {
      if (el !== item) {
        el.classList.remove("active");
        el.querySelector(".accordion-content").classList.add("hidden");
      }
    });

    // toggle current accordion
    const content = item.querySelector(".accordion-content");
    item.classList.toggle("active");
    content.classList.toggle("hidden");

  });
});